// ArChat Auto-Normalized File
// Created: 12-03-2026 22:38:36
// Author: SIVOL® - Aldo Frias - Argentina

/**
 * Autor: SIVOL® - Aldo Frias - Argentina
 * Fecha: 11/03/2026 22:50 (Argentina - UTC-3)
 * ARCHAT — Inicialización opcional de Sentry
 * Solo en production y solo si VITE_SENTRY_DSN está definido.
 * Usa window.Sentry si está cargado (p. ej. por script), sin import que rompa el build.
 *
 * Para activar: cargar @sentry/react vía CDN/script y definir VITE_SENTRY_DSN en el build.
 *
 * @file frontend/src/utils/sentryInit.js
 */

const dsn = typeof import.meta !== 'undefined' && import.meta.env && import.meta.env.VITE_SENTRY_DSN;
const isProd = typeof import.meta !== 'undefined' && import.meta.env && import.meta.env.PROD;

/**
 * Inicializa Sentry si está disponible (window.Sentry o import dinámico tolerante a fallo).
 * Nunca lanza; nunca deja ReferenceError.
 */
export function initSentry() {
  if (!dsn || !isProd) return;
  try {
    const Sentry = typeof window !== 'undefined' ? window.Sentry : null;
    if (Sentry && typeof Sentry.init === 'function') {
      Sentry.init({
        dsn,
        environment: (import.meta.env && import.meta.env.MODE) || 'production',
        beforeSend(event, hint) {
          const msg = hint?.originalException;
          if (msg && typeof msg === 'object' && msg.message) {
            try {
              const parsed = JSON.parse(msg.message);
              if (parsed.error_id) event.tags = { ...event.tags, archat_error_id: parsed.error_id };
              if (parsed.request_id) event.tags = { ...event.tags, archat_request_id: parsed.request_id };
            } catch (_) {}
          }
          return event;
        },
      });
      window.__SENTRY__ = Sentry;
    }
  } catch (_) {}
}
